<template>
    <div>医师团队</div>
</template>

<script>
    import api from "../api";
    import utils from "../common/utils";
    export default {
        data() {
            return {}
        },
        methods: {},
        mounted() {
        }
    }

</script>

<style lang="scss">
    @import "../assets/styles/common.css";
</style>